import React, { useState } from "react";
import "./Login.css";
import Swal from "sweetalert2";

const Login = () => {
  const [form, setForm] = useState({
    mobile: "",
    password: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://rcfinder.online/api/login.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const data = await res.json();
      console.log(data);

      // =====================
      // SUCCESS (ACTIVE + INACTIVE BOTH)
      // =====================
      if (data.status === "success") {
        localStorage.setItem("user", JSON.stringify(data.user));

        Swal.fire({
          title: "Login Successful 🎉",
          text: "Redirecting to Dashboard...",
          icon: "success",
          confirmButtonText: "Continue",
          confirmButtonColor: "#447fffff",
          timer: 2500,
          timerProgressBar: true,
          allowOutsideClick: false
        }).then(() => {
          window.location.href = "/dashboard";
        });

        return;
      }

      // =====================
      // FAILED LOGIN
      // =====================
      Swal.fire({
        icon: "error",
        title: "Login Failed ❌",
        text: data.message || "Invalid Login",
      });

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: "Please try again later",
      });
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">

        <div className="login-left">
          <h2>Welcome Back</h2>
          <p className="sub">Login to continue RC Finder Services</p>

          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="mobile"
              placeholder="Mobile Number"
              required
              onChange={handleChange}
            />

            <input
              type="password"
              name="password"
              placeholder="Password"
              required
              onChange={handleChange}
            />

            <button type="submit" className="submit-btn">
              Login
            </button>
          </form>
        </div>

        <div className="login-right">
          <h1>Hello User!</h1>
          <p>Enter your login details to access your dashboard.</p>

          <span className="register-text">
            Don’t have an account?
            <a href="/register"> Register</a>
          </span>
        </div>

      </div>
    </div>
  );
};

export default Login;
